import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import Button from 'flarum/common/components/Button';

export default function addFeatureControl() {
  extend(DiscussionControls, 'moderationControls', function (items, discussion) {
    if (discussion.attribute('canFeature')) {
      items.add(
        'feature',
        <Button icon={app.forum.attribute('tanka-connector.featuredIcon') || 'fas fa-magic'} onclick={this.featureAction.bind(discussion)}>
          {app.translator.trans(`tanka-connector.forum.discussion_controls.${discussion.attribute('isFeatured') ? 'unfeature' : 'feature'}_button`)}
        </Button>
      );
    }
  });

  DiscussionControls.featureAction = function () {
    this.save({ isFeatured: !this.attribute('isFeatured') }).then(() => {
      if (app.current.matches(DiscussionPage)) {
        app.current.get('stream').update();
      }

      m.redraw();
    });
  };
}
